import React from 'react';

import { Skeleton } from 'src/component/ds/ui/skeleton';

export function TotalSkeleton () {
  return <Skeleton className='ds-h-12 ds-w-[64px]' data-testid='triaged-alarms-total-skeleton' />;
}

export function MetricsSkeleton () {
  return (
    <div className='ds-grid ds-grid-cols-1 ds-gap-8 ds-narrow:ds-grid-cols-2'>
      {[0, 1].map((idx) => (
        <div key={idx} className='ds-flex ds-flex-col ds-gap-4'>
          <Skeleton className='ds-h-6 ds-w-[140px]' />
          <Skeleton className='ds-h-[14px] ds-w-full' />
          <Skeleton className='ds-h-ds-xs ds-w-[120px]' data-testid='triaged-alarms-metric-skeleton' />
        </div>
      ))}
    </div>
  );
}
